import { Link } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";
import { CHANNEL_MANAGER } from "@/lib/role-labels";

export function ForbiddenRoute() {
  return (
    <div className="container flex min-h-[60vh] flex-col items-center justify-center gap-4 py-16 text-center">
      <p className="text-sm font-medium uppercase tracking-wide text-muted-foreground">403</p>
      <h1 className="text-2xl font-semibold tracking-tight">You do not have access to this page</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        Your role doesn't include access to this area. If you think you should have access, send in
        a request via Help and Feedback or contact your {CHANNEL_MANAGER} directly.
      </p>
      <Button asChild className="mt-2">
        <Link to="/dashboard">Back to dashboard</Link>
      </Button>
    </div>
  );
}
